<template>
  <div class="section-h">
    <spinner v-if="isLoading"></spinner>
    <div v-if="!isLoading">
      <h2 class="is-size-3 is-uppercase is-underlined">All League - <span>{{certificates[0].sport}}</span></h2>
      <div class="push-top push-extra">
        <div class="endpoint flex-center" v-for="(obj, idx) in certificates" :key="idx" @click="activeCert = obj">
          {{obj.title}}
        </div>
      </div>
    </div>
    <div v-if="activeCert" class="modal" :class="{'is-active': activeCert}">
      <div class="modal-background"></div>
      <div class="modal-content">
        <img :src="activeCert.image" alt="">
      </div>
      <button class="modal-close is-large" aria-label="close" @click="activeCert = null"></button>
    </div>
  </div>
</template>

<script>
import Certificates from '@/components/Certificates.js';

export default {
  name: 'certificate-detail',
  data() {
    return {
      endpoint: Certificates.List.find(
        c => c.title === this.$route.params.sport
      ),
      activeCert: null
    };
  },
  computed: {
    isLoading() {
      return this.$store.state.pending[this.endpoint.listProperty];
    },
    certificates() {
      let certs = this.$store.state[this.endpoint.listProperty];
      if (!certs.certificates) return;
      return certs.certificates.map(cert => {
        return {
          title: cert.certificate.title,
          year: parseInt(cert.certificate.field_year),
          sport: cert.certificate.field_sport_type,
          image: cert.certificate.field_certificate_image.src,
          keywords: cert.certificate.description
        };
      });
    }
  },
  created() {
    this.$store.dispatch(this.endpoint.listAction);
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/helpers.scss';

.endpoint {
  padding: 0.75em;
  &:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.2);
  }
}
</style>

